import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import type { ExtractedInvoiceFields } from "@shared/types";

export interface ExtractInvoiceCallInput {
  projectId: string;
  pdfStoragePath: string;
}

export interface ExtractInvoiceCallResult {
  extraction: ExtractedInvoiceFields;
  flowVersion: string;
  modelUsed: string;
  inputTokens: number;
  outputTokens: number;
  costUsd: number;
}

export async function callExtractInvoice(
  input: ExtractInvoiceCallInput
): Promise<ExtractInvoiceCallResult> {
  const call = httpsCallable<ExtractInvoiceCallInput, ExtractInvoiceCallResult>(
    functions,
    "extractInvoice"
  );
  const result = await call(input);
  return result.data;
}
